/**
 * Directive for selecting user(s)
 */

angular.module("common").directive("epiUserSelector", function ($http, User, $parse, $timeout, Validator, Session) {
  /**
   * Adds a new property called fullName (concatentation of fname & lname)
   *   Does not return anything, it actually modifies the original object,
   *   thus eliminating the need to return anything
   * @param  {Array} users
   * @return {void}
   */
  function parseUsers(users) {
    for (var i = 0; i < users.length; i++) {
      users[i].fullName = users[i].fname + " " + users[i].lname;
    }
  }

  return {
    restrict: "A",
    scope: {
      showHeader: "=",
      showCurrent: "=?",
      placeholder: "@",
    },
    transclude: true,
    templateUrl: "/directives/epi-user-selector.html",
    controller: function ($scope, $http, User, $timeout, $state) {
      $scope.validation = { emailValid: true, noUsers: false };
      $scope.currentUserID = Session.get("ID");

      if (typeof $scope.showCurrent == "undefined") $scope.showCurrent = false;

      /**
       * Sends a request to the server to search for a user
       *    This fires every time the user starts typing (due to the ng-change on the input)
       * @param  {string} text the user's name (first and/or last) to search for
       * @return {object} the user(s) that were searched for
       */
      $scope.searchUsers = function (text) {
        // Build the parameters
        var params = { params: { name: text, entityID: $state.params.entityID } };

        // Return a promise with a callback
        return $http.get(User.getRestangularUrl() + "/search", params).then(function (response) {
          var users = response.data.data;

          if (!users.length) {
            $scope.validation.noUsers = true;
          } else {
            $scope.validation.noUsers = false;
            parseUsers(users);
          }
          return users;
        });
      };

      $scope.$watch("textQuery", function () {
        if (Validator.validate($scope.textQuery, "email") == true) {
          $scope.validation.emailValid = true;
        } else {
          $scope.validation.emailValid = false;
        }
      });

      $scope.$watch(
        "validation",
        function (validation) {
          if ((validation.emailValid == true && validation.noUsers == true && $scope.allowEmails) || validation.noUsers == false) {
            $scope.invalid = false;
          } else if ((validation.emailValid == false && validation.noUsers == true) || $scope.allowEmails == false) {
            $scope.invalid = true;
          }
        },
        true
      );

      $scope.addUser = function (item, model, label) {
        if ($scope.allowEmails) $scope.users.push({ fullName: item.email, email: item.email });
        else $scope.users.push(item);
        $scope.textQuery = "";
        $scope.invalid = false;
        runAddCallback(item);
      };

      $scope.removeUser = function (index) {
        runRemoveCallback($scope.users[index]);
        $scope.users.splice(index, 1);
      };

      $scope.addEmail = function (email) {
        if (email && email.length && $scope.validation.emailValid && $scope.validation.noUsers && $scope.allowEmails) {
          $scope.users.push({ fullName: email, email: email });
          $scope.textQuery = "";
          runAddCallback({ fullName: email, email: email });
        }
      };

      function runAddCallback(user) {
        $scope.addCallback($scope.$parent, { $users: $scope.users, $user: user, $userID: user.ID });
      }
      function runRemoveCallback(user) {
        $scope.removeCallback($scope.$parent, { $user: user, $userID: user.ID });
      }
    },
    link: function (scope, element, attrs, ctrl, transcludeFn) {
      scope.allowEmails = typeof attrs.allowEmails == "undefined" ? true : attrs.allowEmails === "true";
      scope.addCallback = $parse(attrs.onAdd);
      scope.removeCallback = $parse(attrs.onRemove);
      scope.users = $parse(attrs.users)(scope.$parent);
      scope.textQuery = "";
      scope.transclude = false;

      var showDelete = $parse(attrs.showDelete);

      if (!attrs.showDelete) {
        scope.showDelete = function () {
          return true;
        };
      } else {
        scope.showDelete = function (user) {
          return showDelete(scope.$parent, { user: user });
        };
      }

      scope.$parent.$watch(attrs.users, function (users) {
        scope.users = users;
        if (typeof scope.users == "undefined") {
          throw new ReferenceError("epi-user-selector: no users provided!");
        } else if (scope.users.length) {
          parseUsers(scope.users);
        }
      });

      var transcludedContent = transcludeFn();

      if (transcludedContent.length > 0) scope.transclude = true;

      if (typeof scope.allowEmails == "undefined") scope.allowEmails = false;

      if (typeof scope.placeholder == "undefined") scope.placeholder = scope.allowEmails ? "Add a user/email address here..." : "Add a user here..";
    },
  };
});
